module.exports = __webpack_public_path__ + "img/baozhang.2df30b6a.png";